<template>
  <div>
    <b-container>
      <validation-observer ref="observer" v-slot="{ handleSubmit }">
        <b-form @submit.stop.prevent="handleSubmit(next)" autocomplete="off">
          <b-card>
            <template #header>
              <h6 class="mb-0">Cuestionario médico de asegurabilidad</h6>
            </template>

            <p class="text-muted small mb-3">Responda Sí o No para cada persona a asegurar, según corresponda.</p>

            <div v-for="(persona, indexPersona) in personasConDatos" :key="'pers-' + indexPersona" class="mb-3">
              <b-card no-body class="cuestionario-persona-card">
                <b-card-header
                  role="button"
                  class="d-flex align-items-center justify-content-between py-2 cuestionario-persona-header"
                  @click="togglePersona(indexPersona)"
                >
                  <span class="font-weight-bold mb-0 cuestionario-persona-nombre">
                    {{
                      [persona.name, persona.lastName, persona.secondLastName]
                        .map((s) => (s || "").trim())
                        .filter(Boolean)
                        .join(" ") || "Persona " + (indexPersona + 1)
                    }}
                  </span>
                  <span class="d-flex align-items-center">
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 mr-2 text-secondary d-inline-flex align-items-center"
                      :title="'Marcar todo No'"
                      @click.stop="marcarTodoNo(persona)"
                    >
                      <b-icon icon="dash-circle" font-scale="1.2" />
                    </b-button>
                    <b-button
                      variant="link"
                      size="sm"
                      class="p-0 mr-2 text-secondary d-inline-flex align-items-center"
                      :title="'Limpiar secciones'"
                      @click.stop="limpiarSeccionesPersona(persona)"
                    >
                      <b-icon icon="eraser" font-scale="1.2" />
                    </b-button>
                    <span class="cuestionario-contadas mr-3">
                      {{ contestadasCount(persona) }} de {{ preguntasCount(persona) }}
                    </span>
                    <b-icon
                      :icon="personasAbiertas[indexPersona] ? 'chevron-up' : 'chevron-down'"
                      font-scale="1.1"
                      class="cuestionario-persona-chevron"
                    />
                  </span>
                </b-card-header>
                <b-collapse :visible="personasAbiertas[indexPersona]" :id="'collapse-persona-' + indexPersona">
                  <b-card-body class="pt-2 pb-3">
                    <template v-for="(pregunta, indexPregunta) in PREGUNTAS_CUESTIONARIO_MEDICO">
                      <b-form-group
                        v-if="mostrarPregunta(pregunta, persona)"
                        :key="'p-' + indexPersona + '-' + indexPregunta"
                        class="cuestionario-pregunta"
                      >
                        <b-row
                          v-if="pregunta.type === 'fecha'"
                          align-v="center"
                          class="cuestionario-row cuestionario-row--campo-mujer"
                        >
                          <b-col cols="12" lg="8" class="cuestionario-label-col">
                            <label class="col-form-label font-weight-normal mb-0 text-break">
                              {{ pregunta.code + ". " + pregunta.label }}
                            </label>
                          </b-col>
                          <b-col cols="12" lg="4" class="cuestionario-campo-derecha">
                            <div class="cuestionario-fecha-wrap">
                              <TextComponent
                                :form="persona"
                                name="fechaPregunta22"
                                type="date"
                                label=" "
                                rules="date_min:today|date_max:today+9m"
                              />
                            </div>
                          </b-col>
                        </b-row>

                        <b-row
                          v-else-if="pregunta.type === 'p24'"
                          align-v="end"
                          class="cuestionario-row cuestionario-row--campo-mujer"
                        >
                          <b-col cols="12" lg="5" class="cuestionario-label-col mb-2 mb-lg-0">
                            <label class="col-form-label font-weight-normal mb-0 text-break">
                              {{ pregunta.code + ". " + pregunta.label }}
                            </label>
                          </b-col>
                          <b-col cols="12" lg="7" class="cuestionario-campo-derecha">
                            <div class="cuestionario-p25-grid">
                              <div class="cuestionario-p25-item">
                                <TextComponent
                                  :form="persona.detallePregunta24"
                                  name="nEmbarazos"
                                  label="N° Embarazos"
                                  type="number"
                                  step="1"
                                  rules="required|min_value:0|max_value:20"
                                />
                              </div>
                              <div class="cuestionario-p25-item">
                                <TextComponent
                                  :form="persona.detallePregunta24"
                                  name="nPartos"
                                  label="N° Partos"
                                  type="number"
                                  step="1"
                                  :rules="reglasMaxPartos(persona)"
                                />
                              </div>
                              <div class="cuestionario-p25-item">
                                <TextComponent
                                  :form="persona.detallePregunta24"
                                  name="nAbortos"
                                  label="N° Abortos"
                                  type="number"
                                  step="1"
                                  rules="required|min_value:0|max_value:20"
                                />
                              </div>
                              <div class="cuestionario-p25-item">
                                <TextComponent
                                  :form="persona.detallePregunta24"
                                  name="nCesareas"
                                  label="N° Cesáreas"
                                  type="number"
                                  step="1"
                                  :rules="reglasMaxCesareas(persona)"
                                />
                              </div>
                            </div>
                          </b-col>
                        </b-row>

                        <b-row v-else align-v="center" no-gutters class="cuestionario-row">
                          <b-col class="pr-2 cuestionario-label-col">
                            <label class="col-form-label font-weight-normal mb-0 text-break">
                              {{ pregunta.code + ". " + pregunta.label }}
                            </label>
                          </b-col>
                          <b-col cols="auto" class="cuestionario-sino-wrap">
                            <b-form-radio-group
                              v-model="persona.respuestas[pregunta.pdfRow]"
                              :options="control.TIPOS_SINO"
                              buttons
                              button-variant="outline-primary"
                              size="sm"
                              class="cuestionario-sino"
                              :name="'p-' + indexPersona + '-' + indexPregunta"
                            />
                          </b-col>
                        </b-row>
                      </b-form-group>
                    </template>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>

            <b-alert v-if="personasConDatos.length === 0" show variant="info">
              No hay personas con datos cargados. Complete el paso anterior (Relación de personas a asegurar).
            </b-alert>

            <b-row v-else align-h="end" class="mt-4">
              <b-col md="4" cols="4" style="display: flex; justify-content: flex-end">
                <b-button @click="previous" variant="secondary">Anterior</b-button>
                <b-button type="submit" variant="primary">Siguiente</b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-form>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import TextComponent from "@/components/controls/TextComponent.vue";
import {
  CANTIDAD_FILAS_CUESTIONARIO_SINO,
  PREGUNTAS_CUESTIONARIO_MEDICO,
  TIPOS_SINO,
} from "@/data/colombia/salud/Selects";
const MAX_BENEFICIARIOS_SALUD = 6;

export default {
  name: "FormColombiaSalud03",
  components: { TextComponent },
  data() {
    return {
      control: { TIPOS_SINO },
      PREGUNTAS_CUESTIONARIO_MEDICO,
      personasAbiertas: [],
    };
  },
  computed: {
    form() {
      return this.$store.state.wizard.form || {};
    },
    /** Cada entrada existe porque se agregó en Form02 y debe estar completa. */
    personasConDatos() {
      const list = this.form.dependientes;
      if (!list || !Array.isArray(list)) return [];
      return list;
    },
  },
  created() {
    const form = this.$store.state.wizard.form;
    if (!form || form === null) return;
    if (
      (!form.dependientes || !Array.isArray(form.dependientes) || form.dependientes.length === 0) &&
      form.beneficiarios &&
      Array.isArray(form.beneficiarios) &&
      form.beneficiarios.length > 0
    ) {
      form.dependientes = JSON.parse(JSON.stringify(form.beneficiarios));
    }
    if (!form.dependientes || !Array.isArray(form.dependientes)) {
      form.dependientes = [];
    }
    if (form.dependientes.length > MAX_BENEFICIARIOS_SALUD) {
      form.dependientes = form.dependientes.slice(0, MAX_BENEFICIARIOS_SALUD);
    }
    form.dependientes.forEach((persona) => {
      if (!persona.respuestas || persona.respuestas.length !== CANTIDAD_FILAS_CUESTIONARIO_SINO) {
        this.$set(persona, "respuestas", Array(CANTIDAD_FILAS_CUESTIONARIO_SINO).fill(""));
      }
      if (persona.sex === "F") {
        if (persona.fechaPregunta22 === undefined) this.$set(persona, "fechaPregunta22", "");
        if (!persona.detallePregunta24 || typeof persona.detallePregunta24 !== "object") {
          this.$set(persona, "detallePregunta24", {
            nEmbarazos: "",
            nPartos: "",
            nAbortos: "",
            nCesareas: "",
          });
        } else {
          const d = persona.detallePregunta24;
          if (d.nEmbarazos === undefined) this.$set(d, "nEmbarazos", "");
          if (d.nPartos === undefined) this.$set(d, "nPartos", "");
          if (d.nAbortos === undefined) this.$set(d, "nAbortos", "");
          if (d.nCesareas === undefined) this.$set(d, "nCesareas", "");
        }
      }
    });
    this.personasAbiertas = form.dependientes.map((_, i) => i === 0);
  },
  mounted() {
    this.$store.dispatch("app/loading", true);
    const form = this.$store.state.wizard.form;
    if (form === undefined || form === null) {
      this.$router.push("/form/colombia/salud/");
      this.$store.dispatch("app/loading", false);
      return;
    }
    (form.dependientes || []).forEach((persona) => {
      if (persona.sex === "F") {
        if (persona.fechaPregunta22 === undefined) this.$set(persona, "fechaPregunta22", "");
        if (!persona.detallePregunta24 || typeof persona.detallePregunta24 !== "object") {
          this.$set(persona, "detallePregunta24", {
            nEmbarazos: "",
            nPartos: "",
            nAbortos: "",
            nCesareas: "",
          });
        }
      }
    });
    this.$store.dispatch("app/loading", false);
  },
  methods: {
    mostrarPregunta(pregunta, persona) {
      if (pregunta.type === "sino") {
        return pregunta.pdfRow < 22 || persona.sex === "F";
      }
      return persona.sex === "F";
    },
    reglasMaxPartos(persona) {
      const d = persona.detallePregunta24;
      const max = d && d.nEmbarazos !== "" ? Number(d.nEmbarazos) : 0;
      return `required|min_value:0|max_value:${max}`;
    },
    reglasMaxCesareas(persona) {
      const d = persona.detallePregunta24;
      const max = d && d.nPartos !== "" ? Number(d.nPartos) : 0;
      return `required|min_value:0|max_value:${max}`;
    },
    preguntasCount(persona) {
      return persona.sex === "F" ? 25 : 22;
    },
    contestadasCount(persona) {
      const r = persona.respuestas || [];
      const maxSino = persona.sex === "F" ? CANTIDAD_FILAS_CUESTIONARIO_SINO : 22;
      let count = 0;
      for (let i = 0; i < maxSino && i < r.length; i++) {
        if (r[i] === "S" || r[i] === "N") count++;
      }
      if (persona.sex === "F") {
        if (persona.fechaPregunta22 && String(persona.fechaPregunta22).trim()) count++;
        const d = persona.detallePregunta24;
        if (d && (d.nEmbarazos !== "" || d.nPartos !== "" || d.nAbortos !== "" || d.nCesareas !== "")) {
          count += 1;
        }
      }
      return count;
    },
    togglePersona(index) {
      this.$set(this.personasAbiertas, index, !this.personasAbiertas[index]);
    },
    marcarTodoNo(persona) {
      const r = persona.respuestas || [];
      const maxSino = persona.sex === "F" ? CANTIDAD_FILAS_CUESTIONARIO_SINO : 22;
      for (let i = 0; i < maxSino; i++) {
        this.$set(r, i, "N");
      }
    },
    limpiarSeccionesPersona(persona) {
      this.$set(persona, "respuestas", Array(CANTIDAD_FILAS_CUESTIONARIO_SINO).fill(""));
      if (persona.sex === "F") {
        this.$set(persona, "fechaPregunta22", "");
        this.$set(persona, "detallePregunta24", {
          nEmbarazos: "",
          nPartos: "",
          nAbortos: "",
          nCesareas: "",
        });
      }
    },
    nombrePersona(persona, index) {
      const nombre = [persona.name, persona.lastName, persona.secondLastName]
        .map((s) => (s || "").trim())
        .filter(Boolean)
        .join(" ");
      return nombre || `Persona ${index + 1}`;
    },
    detalleEmbarazosNoCuadra(persona) {
      if (persona.sex !== "F") return false;
      const d = persona.detallePregunta24;
      if (!d) return true;
      const embarazos = Number(d.nEmbarazos);
      const suma = Number(d.nPartos) + Number(d.nAbortos) + Number(d.nCesareas);
      return embarazos !== suma;
    },
    previous() {
      this.$store
        .dispatch("wizard/save", { index: 2, form: this.form })
        .then(() => this.$router.push("/form/colombia-salud-2.html"));
    },
    async next() {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        this.$bvToast.toast("Debe completar los datos obligatorios antes de continuar.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      if (!this.personasConDatos.length) {
        this.$bvToast.toast("No hay personas cargadas para el cuestionario. Vuelva al paso anterior.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      const incompletos = this.personasConDatos.some((p) => {
        const r = p.respuestas || [];
        const maxSino = p.sex === "F" ? CANTIDAD_FILAS_CUESTIONARIO_SINO : 22;
        if (r.length < maxSino) return true;
        for (let i = 0; i < maxSino; i++) {
          if (r[i] !== "S" && r[i] !== "N") return true;
        }
        return false;
      });
      if (incompletos) {
        this.$bvToast.toast("Debe responder Sí o No a todas las preguntas de cada persona.", {
          title: "Validación",
          variant: "warning",
          solid: true,
        });
        return;
      }
      const indexEmbarazosInvalido = this.personasConDatos.findIndex((p) => this.detalleEmbarazosNoCuadra(p));
      if (indexEmbarazosInvalido !== -1) {
        const persona = this.personasConDatos[indexEmbarazosInvalido];
        this.$bvToast.toast(
          `El N° de embarazos debe ser igual a la suma de N° Partos + N° Abortos + N° Cesáreas (${this.nombrePersona(
            persona,
            indexEmbarazosInvalido
          )}).`,
          {
            title: "Validación",
            variant: "warning",
            solid: true,
          }
        );
        return;
      }
      const todoNo = this.personasConDatos.every((p) => {
        const r = p.respuestas || [];
        const maxSino = p.sex === "F" ? CANTIDAD_FILAS_CUESTIONARIO_SINO : 22;
        for (let i = 0; i < maxSino; i++) {
          if (r[i] !== "N") return false;
        }
        return true;
      });
      this.form.saltoForm04 = !!todoNo;
      if (todoNo) {
        this.form.padecimientos = [];
      }
      this.$store.dispatch("wizard/save", { index: 3, form: this.form }).then(() => {
        if (todoNo) {
          if (this.form.actionCode.includes("CO203")) {
            this.$router.push("/form/colombia-salud-6.html");
          } else {
            this.$router.push("/form/colombia-salud-5.html");
          }
        } else {
          this.$router.push("/form/colombia-salud-4.html");
        }
      });
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 100%;
}
.cuestionario-pregunta {
  margin-bottom: 0.5rem;
}
.cuestionario-row {
  min-height: 2.25rem;
}

.cuestionario-row--campo-mujer {
  margin-top: 0.15rem;
}

.cuestionario-campo-derecha {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.cuestionario-fecha-wrap {
  width: 100%;
  max-width: 11.5rem;
  margin-left: auto;
}

.cuestionario-fecha-wrap >>> .form-group {
  margin-bottom: 0;
}

.cuestionario-fecha-wrap >>> label {
  display: none;
}

.cuestionario-p25-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem 0.75rem;
  justify-content: flex-end;
  width: 100%;
}

.cuestionario-p25-item {
  flex: 0 0 auto;
  width: 5.75rem;
  max-width: 6.25rem;
}

.cuestionario-p25-item >>> .form-group {
  margin-bottom: 0;
}

.cuestionario-p25-item >>> label {
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.2rem;
  white-space: nowrap;
  display: block;
  text-align: center;
}

.cuestionario-p25-item >>> .form-control {
  text-align: center;
  padding: 0.3rem 0.35rem;
  height: calc(1.5em + 0.6rem + 2px);
}
/* Colores primario y secundario del proyecto */
.cuestionario-persona-header {
  cursor: pointer;
  background-color: rgba(0, 39, 118, 0.08) !important;
  border-left: 3px solid var(--one);
}
.cuestionario-persona-header:hover {
  background-color: rgba(0, 39, 118, 0.12) !important;
}
.cuestionario-persona-nombre {
  color: var(--one) !important;
}
.cuestionario-persona-chevron {
  color: var(--two) !important;
}
.cuestionario-contadas {
  font-size: 0.9rem;
  font-weight: 500;
  color: var(--four);
}
.cuestionario-sino >>> .btn-outline-primary {
  color: var(--secondary) !important;
  border-color: var(--secondary) !important;
}

/* Cambiar color de hover a azul */
.cuestionario-sino >>> .btn-outline-primary:hover {
  background-color: var(--secondary) !important;
  border-color: var(--secondary) !important;
  color: #fff !important;
}

/* Cambiar color de hover a dorado */
.cuestionario-sino >>> .btn-outline-primary:first-child:hover {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

/* Cambiar color de active a azul */
.cuestionario-sino >>> .btn-outline-primary.active,
.cuestionario-sino >>> .btn-check:checked + .btn-outline-primary {
  background-color: var(--secondary) !important;
  border-color: var(--secondary) !important;
  color: #fff !important;
}

/* Cambiar color de active a dorado */
.cuestionario-sino >>> .btn-outline-primary:first-child.active,
.cuestionario-sino >>> .btn-outline-primary:first-child.btn-active {
  background-color: var(--primary) !important;
  border-color: var(--primary) !important;
  color: #fff !important;
}

@media only screen and (max-width: 1000px) {
  .cuestionario-persona-header {
    flex-wrap: wrap;
    gap: 0.5rem;
  }
  .cuestionario-persona-nombre {
    flex: 1 1 100%;
    min-width: 0;
    word-break: break-word;
  }
  .cuestionario-persona-header > span.d-flex.align-items-center {
    flex-wrap: wrap;
    gap: 0.25rem;
  }
  .cuestionario-row {
    flex-direction: column;
    align-items: stretch;
    min-height: 0;
  }
  .cuestionario-row .col,
  .cuestionario-row [class*="col-"] {
    max-width: 100%;
    flex: 0 0 100%;
  }
  .cuestionario-row .pr-2 {
    padding-right: 0 !important;
    margin-bottom: 0.25rem;
  }
  .cuestionario-sino-wrap {
    margin-top: 0.25rem;
  }
  .cuestionario-campo-derecha {
    justify-content: flex-start;
    margin-top: 0.35rem;
  }
  .cuestionario-fecha-wrap {
    max-width: 100%;
    margin-left: 0;
  }
  .cuestionario-p25-grid {
    justify-content: stretch;
  }
  .cuestionario-p25-item {
    width: calc(50% - 0.375rem);
    max-width: none;
  }
}
</style>
